import { useState } from "react";
import { Badge, Collapse, Group, Tooltip, rem } from "@mantine/core";
import { NavLink } from "react-router-dom";
import classes from "./Navbar.module.css";
import { IconChevronRight } from "@tabler/icons-react";

function NavbarLink({ item, disabled, onClick, collapsed, badge }) {
  const initiallyOpened =
    item?.links?.some((link) => link.path === window.location.pathname) ||
    false;

  const [opened, setOpened] = useState(initiallyOpened);
  const hasLinks = item.links && item.links.length > 0;

  const items = (hasLinks ? item.links : []).map((link) => (
    <NavLink
      to={link.path}
      key={link.label}
      className={({ isActive }) =>
        isActive ? `${classes.linkInner} ${classes.active}` : classes.linkInner
      }
      end
    >
      <span>{link.label}</span>
    </NavLink>
  ));

  if (disabled) {
    return (
      <Tooltip
        label={item.label}
        position="right"
        withArrow
        disabled={!collapsed}
      >
        <div
          className={`${classes.link} ${classes.disabled} ${collapsed ? classes.linkCollapsed : ""}`}
          style={{ opacity: 0.5 }}
        >
          {item.icon && <item.icon stroke={1.5} className={classes.linkIcon} />}
          {!collapsed && <span>{item.label}</span>}
        </div>
      </Tooltip>
    );
  }

  const linkContent = (
    <NavLink
      to={item.path}
      key={item.label}
      className={({ isActive }) =>
        `${classes.link} ${isActive ? classes.active : ""} ${collapsed ? classes.linkCollapsed : ""}`
      }
      end
      onClick={() => {
        setOpened((o) => !o);
        onClick?.();
      }}
    >
      {item.icon && <item.icon stroke={1.5} className={classes.linkIcon} />}
      {!collapsed && <span>{item.label}</span>}
      {!collapsed && badge && (
        <Badge size="xs" variant="light" color="gray" ml="auto">
          {badge}
        </Badge>
      )}
    </NavLink>
  );

  return (
    <>
      <Group justify="space-between" gap={0}>
        {collapsed ? (
          <Tooltip label={item.label} position="right" withArrow>
            <div>{linkContent}</div>
          </Tooltip>
        ) : (
          linkContent
        )}
        {hasLinks && !collapsed && (
          <IconChevronRight
            className={classes.chevron}
            stroke={1.5}
            style={{
              width: rem(16),
              height: rem(16),
              transform: opened ? "rotate(-90deg)" : "none",
            }}
          />
        )}
      </Group>
      {hasLinks && !collapsed ? (
        <Collapse expanded={opened}>{items}</Collapse>
      ) : null}
    </>
  );
}

export default NavbarLink;
